import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { environment } from '../../../environments/environment';

import { AlertService } from '../../_common/alert/alert.service';
import { MarketingService } from '../../_services/marketing.service';
import { StyleService } from '../../_services/style.service';
import { MarketingContact } from '../../_models/marketing-contact';

@Component({
    selector: 'app-layout-footer',
    styleUrls: ['./layout-footer.component.scss'],
    templateUrl: './layout-footer.component.html'
})
export class LayoutFooterComponent implements OnInit {
    isShowingFooter = true;
    isSubmitting = false;
    marketingContactForm: FormGroup;

    backgroundColor: string;
    fontColor: string;

    constructor(
        private readonly route: ActivatedRoute,
        private readonly alertService: AlertService,
        private readonly marketingService: MarketingService,
        private readonly styleService: StyleService,
        private formBuilder: FormBuilder) {
    }

    ngOnInit(): void {
        this.subscribeToStyling();

        this.route.queryParams.subscribe((params) => {
            if (params['app']) {
                this.isShowingFooter = false;
            }
        });

        this.marketingContactForm = this.formBuilder.group({
            signUpEmail: ['', Validators.required]
        });
    }

    isEventActive(eventName): boolean {
        switch(eventName) {
            case "cottonBowl":
                return environment.cottonBowlEventId > 0;
            case "orangeBowl":
                return environment.orangeBowlEventId > 0;
            case "fiestaBowl":
                return environment.fiestaBowlEventId > 0;
            case "playoffSemifinal":
                return environment.playoffSemifinalEventId > 0;
            case "peachBowl":
                return environment.peachBowlEventId > 0;
            case "sugarBowl":
                return environment.sugarBowlEventId > 0;
            case "roseBowl":
                return environment.roseBowlEventId > 0;
            default:
                return false;
        }
    }

    submitMarketingContact(): void {
        this.isSubmitting = true;

        const marketingContact = new MarketingContact();
        marketingContact.email = this.marketingContactForm.controls.signUpEmail.value;

        this.marketingService.signUpForUpdates(marketingContact).subscribe(
            () => {
                this.alertService.success(`${marketingContact.email} has been successfully added.`);
                this.isSubmitting = false;
            },
            (errors: any) => {
                this.alertService.error(errors);
                this.isSubmitting = false;
            }
        );
    }

    private subscribeToStyling() {
        this.styleService.getFooterStyling().subscribe(message => {
            if (message != null) {
                this.backgroundColor = message.backgroundColor;
                this.fontColor = message.fontColor;
            } else {
                this.backgroundColor = null;
                this.fontColor = null;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/layout/layout-footer/layout-footer.component.ts